'use strict';

const { h, Component } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');
const { hydrate } = require('@grpn/hydration');

const getPrimaryCategoryIds = require('../../support/primary-category-ids');
const CouponSmall = require('./coupon-small');

class CouponsCategoryTabs extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.state = { activeTab: 0 };
  }

  render() {
    const { coupons, routes } = this.props;
    const { activeTab } = this.state;
    const groups = this.getCategoryItems();

    return h(
      '.coupons-category-tabs',
      {
        'data-bhw': 'PopularCategories',
      },
      [
        h(
          Translate,
          { tag: 'h2', attrs: { class: 'secondary-title' } },
          'js.modules.home.CategoryDeals'
        ),
        h('.coupons-category-tabs-inner', [
          h('nav.coupons-category-tabs-menu', [
            h('ul.coupons-category-tabs-list', [
              ...groups.map(({ id, name, icon }, index) =>
                this.getCategoryListItem({ id, name, icon, index })
              ),
              h('li.coupons-category-tabs-item', [
                h(WithI18n, {}, i18n =>
                  h(
                    'a',
                    {
                      class: 'coupons-category-tabs-link view-more',
                      href: routes.category.main,
                      'aria-label': i18n.t('js.modules.shared.ViewMore'),
                      'data-bhc': 'category:ViewMore',
                    },
                    i18n.t('js.modules.shared.ViewMore')
                  )
                ),
              ]),
            ]),
          ]),
          h(
            '.coupons-category-tabs-content',
            coupons.map((group, index) =>
              h(
                '.coupons-category-tabs-group',
                { class: index === activeTab && 'active' },
                group.map(coupon =>
                  h('div.coupons-category-tabs-group-item', [
                    h(CouponSmall, { coupon, routes }),
                  ])
                )
              )
            )
          ),
        ]),
      ]
    );
  }

  getCategoryListItem({ id, name, icon, index }) {
    const { activeTab } = this.state;

    return h(WithI18n, {}, i18n =>
      h('li.coupons-category-tabs-item', [
        h(
          'a.coupons-category-tabs-link',
          {
            class: index === activeTab && 'active',
            onClick: this.clickHandlerTab.bind(this, index),
            'aria-label': i18n.t(
              'js.modules.home.CategoryDealsLinkAriaFormat',
              { 0: name }
            ),
            'data-bhc': `category:${name}`,
          },
          [
            h(`span.coupons-category-tabs-link-icon.${icon}`),
            h(
              'span.coupons-category-tabs-link-text',
              i18n.t(`js.modules.category.Name.${id}`)
            ),
          ]
        ),
      ])
    );
  }

  clickHandlerTab(index) {
    this.setState({
      activeTab: index,
    });
  }

  getCategoryItems() {
    const { keyAuthData } = this.props;
    const idList = getPrimaryCategoryIds(keyAuthData.categories);

    const result = idList.map(id => this.getCategoryData(id));

    return result;
  }

  getCategoryData(id) {
    const { categoryData } = this.props;
    const data = categoryData.filter(item => item.Id === id)[0];

    return {
      id,
      name: data && data.Name,
      icon: `icon-category-${id}`,
    };
  }
}

module.exports = hydrate('CouponsCategoryTabs', CouponsCategoryTabs);
